import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { hoaTheoDip, hoaHopTui, dipConfig, mucGiaConfig, getFlowerImage, formatGia } from "./flowerData";

const allFlowers = [...hoaTheoDip, ...hoaHopTui];

export default function FlowerDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const hoa = allFlowers.find((h) => h.id === id);

  const [qty, setQty] = useState(1);
  const [imgError, setImgError] = useState(false);
  const [added, setAdded] = useState(false);

  if (!hoa) {
    return (
      <div style={{ textAlign: "center", padding: "120px 24px" }}>
        <p style={{ fontSize: 48 }}>🌸</p>
        <h2 style={{ color: "#1a1a1a" }}>Không tìm thấy sản phẩm</h2>
        <button onClick={() => navigate(-1)} style={backBtn}>← Quay lại</button>
      </div>
    );
  }

  const isDip = hoa.dip !== undefined;
  const configLabel = isDip ? dipConfig[hoa.dip] : mucGiaConfig[hoa.muc];
  const accentColor = configLabel?.mauBadge || configLabel?.mau || "#ff66a2";

  // Sản phẩm liên quan
  const lienQuan = allFlowers
    .filter((h) => {
      if (h.id === hoa.id) return false;
      if (isDip) return h.dip === hoa.dip;
      return h.muc === hoa.muc;
    })
    .slice(0, 4);

  const themGioHang = () => {
    const cart = JSON.parse(localStorage.getItem("sellixy_cart") || "[]");
    const idx = cart.findIndex((i) => i.id === hoa.id);
    if (idx >= 0) {
      cart[idx].quantity = (cart[idx].quantity || 1) + qty;
    } else {
      cart.push({ id: hoa.id, name: hoa.ten, price: hoa.gia, img: null, ma: hoa.ma, quantity: qty });
    }
    localStorage.setItem("sellixy_cart", JSON.stringify(cart));
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  const datHang = () => {
    themGioHang();
    navigate("/gio-hang-cua-ban");
  };

  return (
    <div style={{ background: "#fff", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>

      {/* BREADCRUMB */}
      <div style={breadcrumb}>
        <span style={crumbLink} onClick={() => navigate("/")}>Trang chủ</span>
        <span style={crumbSep}>/</span>
        <span
          style={crumbLink}
          onClick={() => navigate(isDip ? `/dung-dip/${hoa.dip}` : `/hop-tui/${hoa.muc}`)}
        >
          {configLabel?.label || "Sản phẩm"}
        </span>
        <span style={crumbSep}>/</span>
        <span style={{ color: "#1a1a1a", fontWeight: 600 }}>{hoa.ten}</span>
      </div>

      {/* MAIN CONTENT */}
      <div style={mainGrid}>

        {/* Ảnh */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          style={imgSection}
        >
          <div style={imgBox}>
            {imgError ? (
              <div style={imgFallback}>{configLabel?.icon || "🌸"}</div>
            ) : (
              <img
                src={getFlowerImage(hoa.ma)}
                alt={hoa.ten}
                style={mainImg}
                onError={() => setImgError(true)}
              />
            )}
          </div>
        </motion.div>

        {/* Thông tin */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          style={infoSection}
        >
          {/* Badge */}
          <div style={{ marginBottom: 12 }}>
            <span style={{ ...tag, background: accentColor }}>
              {configLabel?.icon} {configLabel?.label}
            </span>
          </div>

          <h1 style={productTitle}>{hoa.ten}</h1>

          <div style={priceRow}>
            <span style={{ ...price, color: accentColor }}>{formatGia(hoa.gia)}</span>
          </div>

          <div style={divider} />

          {/* Thành phần */}
          <div style={section}>
            <h3 style={sectionTitle}>🌿 Thành phần hoa</h3>
            <div style={ingredientBox}>
              {hoa.thanhPhan.split("\n").map((line, i) => (
                <p key={i} style={ingredient}>{line.replace(/^- /, "")}</p>
              ))}
            </div>
          </div>

          <div style={divider} />

          {/* Mô tả / Ý nghĩa */}
          <div style={section}>
            <h3 style={sectionTitle}>💌 Ý nghĩa</h3>
            <p style={description}>{hoa.moTa}</p>
          </div>

          <div style={divider} />

          {/* Chọn số lượng & Nút */}
          <div style={section}>
            <div style={qtyRow}>
              <span style={{ fontSize: 14, fontWeight: 600, color: "#444" }}>Số lượng:</span>
              <div style={qtyBox}>
                <button style={qtyBtn} onClick={() => setQty(Math.max(1, qty - 1))}>−</button>
                <span style={qtyNum}>{qty}</span>
                <button style={qtyBtn} onClick={() => setQty(qty + 1)}>+</button>
              </div>
            </div>

            <div style={actionRow}>
              <motion.button
                whileHover={{ scale: 1.02, background: added ? "#22c55e" : "#e0558e" }}
                whileTap={{ scale: 0.97 }}
                style={{ ...btnCart, background: added ? "#22c55e" : "#ff66a2" }}
                onClick={themGioHang}
              >
                {added ? "✓ Đã thêm!" : "🛒 Thêm vào giỏ hàng"}
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.02, background: accentColor }}
                whileTap={{ scale: 0.97 }}
                style={{ ...btnOrder, background: accentColor }}
                onClick={datHang}
              >
                Mua ngay
              </motion.button>
            </div>
          </div>

          {/* Ưu đãi đặc biệt */}
          <div style={promoBox}>
            <p style={promoItem}>🚚 Giao hàng nhanh trong ngày tại TP.HCM</p>
            <p style={promoItem}>🎁 Miễn phí thiệp viết tay kèm hoa</p>
            <p style={promoItem}>🌸 Cam kết hoa tươi 100% — đổi trả nếu không hài lòng</p>
          </div>
        </motion.div>
      </div>

      {/* SẢN PHẨM LIÊN QUAN */}
      {lienQuan.length > 0 && (
        <div style={relatedSection}>
          <h2 style={relatedTitle}>Sản phẩm liên quan</h2>
          <div style={relatedGrid}>
            {lienQuan.map((item, i) => {
              const rConfig = item.dip ? dipConfig[item.dip] : mucGiaConfig[item.muc];
              const rColor = rConfig?.mauBadge || rConfig?.mau || "#ff66a2";
              return (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.08 }}
                  whileHover={{ y: -5, boxShadow: "0 12px 32px rgba(0,0,0,0.1)" }}
                  style={relatedCard}
                  onClick={() => { navigate(`/hoa/${item.id}`); window.scrollTo(0, 0); }}
                >
                  <div style={relImgWrap}>
                    <img
                      src={getFlowerImage(item.ma)}
                      alt={item.ten}
                      style={relImg}
                      onError={(e) => { e.target.style.display = "none"; }}
                    />
                  </div>
                  <div style={{ padding: "12px 14px" }}>
                    <p style={relName}>{item.ten}</p>
                    <p style={{ ...relPrice, color: rColor }}>{formatGia(item.gia)}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

/* ---- STYLES ---- */
const breadcrumb = { padding: "16px 32px", fontSize: 13, color: "#888", display: "flex", alignItems: "center", gap: 6 };
const crumbLink = { cursor: "pointer", color: "#888", transition: "color 0.2s" };
const crumbSep = { color: "#ccc" };

const mainGrid = {
  display: "grid", gridTemplateColumns: "1fr 1fr",
  gap: 48, maxWidth: 1100, margin: "0 auto", padding: "24px 32px 64px",
};
const imgSection = {};
const imgBox = {
  borderRadius: 24, overflow: "hidden", background: "#fafafa",
  border: "1px solid #f0f0f5", height: 520,
  position: "sticky", top: 90,
};
const mainImg = { width: "100%", height: "100%", objectFit: "cover" };
const imgFallback = { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 100 };

const infoSection = {};
const tag = { padding: "5px 14px", borderRadius: 20, fontSize: 12, fontWeight: 700, color: "#fff" };
const productTitle = { fontSize: "clamp(22px, 3vw, 32px)", fontWeight: 800, color: "#1a1a1a", margin: "8px 0 12px", lineHeight: 1.25 };
const priceRow = { marginBottom: 4 };
const price = { fontSize: 28, fontWeight: 900 };
const divider = { height: 1, background: "#f0f0f5", margin: "20px 0" };
const section = { marginBottom: 4 };
const sectionTitle = { fontSize: 14, fontWeight: 700, color: "#555", margin: "0 0 10px", textTransform: "uppercase", letterSpacing: "0.5px" };
const ingredientBox = { background: "#fafafa", borderRadius: 12, padding: "14px 16px", border: "1px solid #f0f0f5" };
const ingredient = { margin: "4px 0", fontSize: 14, color: "#333", display: "flex", alignItems: "center", gap: 6 };
const description = { fontSize: 14.5, lineHeight: 1.8, color: "#555", margin: 0 };

const qtyRow = { display: "flex", alignItems: "center", gap: 16, marginBottom: 16 };
const qtyBox = { display: "flex", alignItems: "center", border: "1.5px solid #e0e0e0", borderRadius: 10, overflow: "hidden" };
const qtyBtn = { width: 36, height: 36, border: "none", background: "#fafafa", fontSize: 18, cursor: "pointer", color: "#333", fontWeight: 700 };
const qtyNum = { width: 40, textAlign: "center", fontSize: 15, fontWeight: 700, color: "#1a1a1a" };

const actionRow = { display: "flex", gap: 12, flexWrap: "wrap" };
const btnCart = {
  flex: 1, minWidth: 160, padding: "14px 20px", borderRadius: 14, border: "none",
  color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", transition: "all 0.2s",
};
const btnOrder = {
  flex: 1, minWidth: 120, padding: "14px 20px", borderRadius: 14, border: "none",
  color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", transition: "all 0.2s",
};

const promoBox = {
  marginTop: 20, padding: "16px 20px", background: "#fff8fc",
  borderRadius: 14, border: "1px solid #ffe0ef",
};
const promoItem = { margin: "6px 0", fontSize: 13, color: "#555" };

const backBtn = {
  marginTop: 16, padding: "10px 24px", borderRadius: 10,
  background: "#ff66a2", color: "#fff", border: "none", fontSize: 14,
  fontWeight: 600, cursor: "pointer",
};

const relatedSection = { padding: "0 32px 80px", maxWidth: 1100, margin: "0 auto" };
const relatedTitle = { fontSize: 22, fontWeight: 800, color: "#1a1a1a", marginBottom: 24 };
const relatedGrid = {
  display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 20,
};
const relatedCard = {
  background: "#fff", borderRadius: 16, overflow: "hidden",
  border: "1px solid #f0f0f5", cursor: "pointer",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)", transition: "all 0.3s",
};
const relImgWrap = { height: 180, overflow: "hidden", background: "#fafafa" };
const relImg = { width: "100%", height: "100%", objectFit: "cover" };
const relName = { margin: "0 0 6px", fontSize: 14, fontWeight: 700, color: "#1a1a1a" };
const relPrice = { margin: 0, fontSize: 14, fontWeight: 800 };
